import {
	CheckCircleOutlined,
	ExclamationCircleOutlined,
	FieldTimeOutlined,
	LoadingOutlined,
	SyncOutlined,
} from '@ant-design/icons';
import { Avatar, Button, Flex, Space, Tooltip, Typography } from 'antd';
import { SortOrder } from 'antd/es/table/interface';
import Link from 'antd/es/typography/Link';

import { ContentMonitorItem } from '@/api/monitor_collections';
import prepareDate from '@/lib/helpers/prepareDate';

const columns = [
	{
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		hidden: true,
		render: (_: any, record: ContentMonitorItem) => {
			return <p title={'' + record?.id}>{record.title}</p>;
		},
	},
	{
		title: 'Date/time',
		dataIndex: 'created_at',
		key: 'created_at',
		sorter: true,
		sortDirections: ['ascend', 'descend', 'ascend'] as SortOrder[],
		width: 80,
		// flex: true,
		// ellipsis: true,
		// hidden: true,
		render: (_: any, record: ContentMonitorItem) => {
			return (
				<>
					{record?.created_at
						? prepareDate('' + record?.created_at)
						: 'no date'}
				</>
			);
		},
	},
	{
		title: 'Status / Title',
		dataIndex: 'title',
		sorter: true,

		key: 'title',
		width: 100,
		ellipsis: true,
		render: (_: any, record: ContentMonitorItem) => {
			const preparedTitle =
				(record?.title || record?.description)?.length > 90
					? (record?.title || record?.description).slice(0, 90) + '...'
					: record?.title || record?.description;

			return (
				<Space size={[4, 1]}>
					{record?.active ? (
						<CheckCircleOutlined style={{ color: '#58c622' }} />
					) : (
						<FieldTimeOutlined style={{ color: 'gray' }} />
					)}
					{preparedTitle}
				</Space>
			);
		},
	},
	{
		title: 'Description',
		dataIndex: 'description',
		key: 'description',
		width: 200,
		ellipsis: true,
		render: (_: any, record: ContentMonitorItem) => {
			return <Space size={[8, 1]}>{record?.description || ''}</Space>;
		},
	},
	{
		title: 'Categories amount',
		dataIndex: 'items_amount',
		key: 'items_amount',
		width: 80,
		ellipsis: true,
		render: (_: any, record: ContentMonitorItem) => {
			return (
				<Flex style={{ width: '100%' }} justify="center" align="center">
					{record?.items_amount || 0}
				</Flex>
			);
		},
	},
];

export { columns };
